



































import settings from '@/settings'
import n from '@/utils/notifications'
import q from '@/graphql/query'

export default {
    name: 'nav_bar'

    props:{
        change_distribution:{
            required: false
            type: Boolean
        }
    }

    watch:
        "change_distribution": (new_value, old_value)->
            # console.log "EMIT NAV BAR", new_value, old_value
            if @$store.state.user_datas.profiles.indexOf('distributor') != -1 || @$store.state.user_datas.profiles.indexOf('superadmin') != -1
                if new_value != old_value
                    @distributions = []
                    @get_distributions()

        "$store.state.user_datas": (value)->
            if value?
                @email = value.app_user.email

    data: ()->
        selected_company: {uid:'', name:''}
        white_label_logo_url: ""
        distributions: []
        email: ""
        clearable: true
        companies_selector_classes: ''

    methods:
        strap_clicked: ()->
            if @companies_selector_classes == ''
                @companies_selector_classes = 'active'
            else
                @companies_selector_classes = ''

        handle_command: (command)->
            if command == "logout"
                @logout()
            else
                if @$router.currentRoute.name != "users_account"
                    @reset_selected_company()
                    @$router.push(name:'users_account')
            return

        change_selected_company_uid: (value)->
            # console.log "CHANGE SELECTED COMPANY", value
            if value != ""
                distribution = @distributions.find (x)->
                    return x.company.uid == value
                @$store.commit('set_selected_company', distribution.company)
                localStorage.setItem("selected_company", JSON.stringify(distribution.company))
                @$router.push(name:'company_company', params:{uid:value})
            else
                @reset_selected_company()
                @$router.push(name:'dashboard')
                .catch((err)-> {})
            # console.log "CHANGE SELECTED COMPANY", company
            # console.log "CHANGE LOCALE ", localStorage.getItem("selected_company")
            return

        reset_selected_company: ()->
            if @$store.state.user_datas.profiles.indexOf('distributor') != -1 || @$store.state.user_datas.profiles.indexOf('superadmin') != -1
                @$store.commit('set_selected_company', {uid:'', name:''})
                @selected_company = {uid:'', name:''}
                localStorage.setItem("selected_company", JSON.stringify({uid:'', name:''}))
                # console.log "RESET SELECTED COMPANY", @selected_company, @$store.state.selected_company

        select_style: (count)->
            return "margin-left:"+(count*15).toString()+"px;"

        distributions_factory: (distribution, count)->
            if distribution.company.is_active
                @distributions.push({uid:distribution.uid, company:distribution.company, count:count})
            count++
            for key, value of distribution.children
                @distributions_factory(value, count)
            # console.log "DISTRIBUTIONS FACTORY", @distributions
            @$store.commit('set_distribution_set', @distributions)
            return

        get_distributions: ()->
            self = @
            q.run('get_distribution_set', [@$store.state.user_datas.company.uid])
            .then (resp)->
                # console.log "GET DISTRIBUTIONS", resp.body.data.distribution_set
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("nav_bar: get_distributions: then" ,e.message)
                else 
                    self.distributions_factory(resp.body.data.distribution_set[0], 1)
                    self.reload_support()
            .catch (resp)->
                n.catch_error(resp, "nav_bar: get_distributions()")

        reload_support: ()->
            locale_company = JSON.parse(localStorage.getItem("selected_company"))
            locale_app_user = JSON.parse(localStorage.getItem("selected_app_user"))

            # console.log "LOCALE COMPANY UID : ", locale_company
            if locale_company? and locale_company.uid != ""
                current_distribution = @distributions.filter (x)->
                    return x.company.uid == locale_company.uid
                # console.log "RELOAD SUPPORT : ", current_distribution
                if current_distribution.length > 0
                    @$store.commit("set_selected_company", current_distribution[0].company)
                else
                    @selected_company = {uid:'', name:''}
            if locale_app_user? and locale_app_user.uid != ""
                @$store.commit("set_selected_app_user", locale_app_user)
            # else if @$store.state.selected_company.uid != ""
            #     localStorage.setItem("selected_company", JSON.stringify(@$store.state.selected_company))            

        logout: ()->
            self = @
            # console.log "LOGOUT"
            loading = @$loading({
                lock: true,
                text: 'Déconnexion',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 1)'
            })
            @$store.commit("logout")
            @$route.params.next = "/"
            @$http.get(settings.logout_url)
            .then (resp)->
                if resp.body.status == "loggedout"
                    n.success_message(resp.body.message)
                    location.replace(location.origin)

    beforeMount: ()->
        # console.log "NAV BAR before mount", @$store.state.selected_company
        if @$store.state.user_datas.profiles.indexOf('distributor') != -1 || @$store.state.user_datas.profiles.indexOf('superadmin') != -1
            @get_distributions()

    mounted: ()->
        @email = @$store.state.user_datas.app_user.email
        @selected_company = @$store.state.selected_company
        if @$store.state.user_datas.company.white_label_logo?
            @white_label_logo_url = settings.media_url+@$store.state.user_datas.company.white_label_logo
        else
            @white_label_logo_url = settings.frontend_url+'/assets/img/logo.svg'
        # console.log "NAV BAR MOUNTED", @$store.state.selected_company
        # console.log "NAV BAR MOUNTED", @selected_company
}
